import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import UsersTable from "./../../elements/users/usersTable";
import UsersSearch from "../../elements/users/widget/users_search";
import UsersAdd from '../../elements/users/widget/users_add';
import UsersExport from '../../elements/users/widget/users_export';

class Users extends Component {
	render(){
		return(
			<UsersTable {...this.props.users} usersList={this.props.usersList} userDelete={this.props.userDelete}/>
		);
	}

	componentWillMount(){
		const { users } = this.props;
		this.props.fetchStatus(1);
		this.props.fetchRolesList();
		this.props.usersList(users.pages.current, users.filters);
	}
}

export default BaseLayout(Users, {
	title: `Administrar Usuarios`,
	subnav: {
		icon: 'fa-users',
		name: 'Usuarios',
		actions: [
			{
				type: 'search',
				url: null,
				name: 'Buscar',
				element: <UsersSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Exportar',
				element: <UsersExport />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <UsersAdd />
			}
		]
	}
});



// WEBPACK FOOTER //
// ./src/layouts/users/index.jsx